import { useMemo } from 'react'
import { Token, TokenAmount } from '@etcswapv2/sdk-legacy'
import ERC20_INTERFACE from '../constants/abis/erc20'
import { useMultipleContractSingleData, EthersInterface } from '../state/multicall/hooks'

/**
 * Returns the total supply of a token.
 *
 * Uses useMultipleContractSingleData with ERC20_INTERFACE directly
 * instead of useSingleCallResult with a viem contract, because viem
 * contracts don't have the .interface property that multicall hooks expect.
 *
 * @param token - The token to get total supply for
 * @returns TokenAmount representing total supply, or undefined if loading/error
 */
export function useTotalSupply(token?: Token): TokenAmount | undefined {
  // Build addresses array - empty if no token
  const addresses = useMemo(() => (token ? [token.address] : []), [token])

  // Use the working pattern: pass Interface directly instead of contract
  const results = useMultipleContractSingleData(
    addresses,
    ERC20_INTERFACE as unknown as EthersInterface,
    'totalSupply'
  )

  // Get the first (and only) result
  const totalSupplyResult = results[0]
  const totalSupply = totalSupplyResult?.result?.[0]

  return useMemo(() => {
    if (!token || !totalSupply) return undefined
    return new TokenAmount(token, totalSupply.toString())
  }, [token, totalSupply])
}
